
<template>
  <div>
    <v-col cols='12'>
      <div class="mt-2 mb-2">
        <input type="file" accept="application/pdf, image/*" style="display: none" id="file" ref="file" @change="handleFile()">
      </div>
      <v-btn rounded color="info" class="font-weight-bold" @click="$refs.file.click()"> 
        <v-icon left style="font-size: 20px">mdi-camera</v-icon> {{ existing_doc? 'Alterar ' : 'Adicionar ' }} anexo
      </v-btn>
      <v-row justify='center'>
        <template v-if="existing_doc && existing_doc && !newAttachment">
          <iframe v-if="existing_doc_is_doc && !isMobile" :src="existing_doc" width="400" height="500"></iframe>
          <v-img v-if="existing_doc_is_image" :src="existing_doc" width="400" height="500" contain></v-img>
          <v-btn text small color="primary" @click="downloadDocument(existing_doc)" rounded><v-icon left small>mdi-download</v-icon> Baixar Documento</v-btn>
        </template>
        <template v-if="newAttachment">
          <v-col cols='10'>
            <iframe v-if="attachment_attributes.type.includes('pdf') && !isMobile" :src="newAttachment" width="400" height="500"></iframe>
            <v-img v-if="attachment_attributes.type.includes('ima')" :src="newAttachment" width="400" height="500" contain></v-img>
            <div>
              <v-row>
                {{attachment_attributes.name}}
                <v-spacer></v-spacer>
                <v-btn icon @click="removeFile()"> <v-icon color="red">mdi-delete</v-icon> </v-btn> 
              </v-row>
            </div>
          </v-col>
        </template>
      </v-row>
    </v-col>
  </div>
</template>

<script>

export default {
  name: 'AttachDoc',
  props: {
    existing_doc: {
      type: String,
    },
    mode:{
      type: String,
      default: 'active_storage'
    }
  },
  data() {
    return {
      key: null,
      attach: false,
      newAttachment: '',
      attachment_attributes: {},

      document_attributes: {
        data: null,
        filename: null,
        content_type: null,
      }
    }
  },
  methods: {
    downloadDocument(url){
      window.open(url, '_blank')
    },
    handleFile(){
      var uploadedFiles = this.$refs.file.files;
      this.attachment_attributes = uploadedFiles[0];
      var fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.newAttachment = fileReader.result
        this.document_attributes = {
          data: this.newAttachment,
          filename: this.attachment_attributes.name,
          content_type: this.attachment_attributes.type,
        }
        let obj = {}
        const {data, filename, content_type} = this.document_attributes
        if (this.mode == 'carrier'){
          obj = {
            url_document: data,
            name: filename,
            kind: content_type,
          }
        } else if (this.mode == 'active_storage'){
          obj = { data, filename, content_type }
        }
        this.$emit('donePhoto', obj)
        this.attach = true
      })
      fileReader.readAsDataURL(this.attachment_attributes)
    },
    removeFile(i){
      this.attachment_attributes = null
      this.newAttachment = ''
      this.$emit('removePhoto')
      this.attach = false
    },

  },
  computed: {
    existing_doc_is_image() {
      if (this.existing_doc){
        return this.existing_doc.includes('.ima') || this.existing_doc.includes('.jpg') || this.existing_doc.includes('.jpeg') || this.existing_doc.includes('.png')
      }
      return null 
    },
    existing_doc_is_doc() {
      if (this.existing_doc){
        return this.existing_doc.includes('.pdf') 
      }
      return null 
    },

  },
  watch: {
    attach(nv,ov) {
      this.$emit('attachChanged', nv)
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>
